import { createGlobalStyle } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html{
   scroll-behavior: smooth;

   @media (max-width: 1080px) {
      font-size: 93.75%;
    }

    @media (max-width: 720px) {
      font-size: 87.5%;
    }
  }

  body {
    -webkit-font-smoothing: antialiased;
    background: ${({ theme }) => theme.colors.primary};
  }

  div.swal2-popup {
    background: ${({ theme }) => theme.colors.bg} !important;
  }

  .css-tj5bde-Svg {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  html, body, #root, main {
    min-height: 100%;
    height: 100%;
  }

  body, input, button, textarea {
    font-family: 'Montserrat', sans-serif;
  }

  button, input, select{
    outline: none;
    &:focus {
      outline: transparent !important;
    }
  }

  ul {
    list-style: none;
  }

  a{
    text-decoration: none !important;
  }

  [disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .Toastify__toast--success {
    background: #ed8514;
  }

  .nav-pills {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 0.5rem;
    overflow: hidden;
  }

  .nav-pills .nav-link {
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  .nav-pills .nav-link.active,
  .nav-pills .show>.nav-link {
    color: ${({ theme }) => theme.colors.textPrimary};
    background: linear-gradient(90deg, rgba(255,152,2,1) 0%, rgba(245,174,8,1) 50%, rgba(254,186,15,1) 100%);
    border-radius: 0.5rem;
  }

  .nav-pills .styles-module_sliderBase__swkx1>[data-arrow=left] {
    bottom: 0;
    height: 42px;
    margin-bottom: auto;
    margin-top: auto;
    width: 88px;
    position: absolute;
    top: 0;
    opacity: 1;
    cursor: pointer;
    background: linear-gradient(90deg,#fff 10%,hsla(0,0%,100%,0));

    background: ${({ theme }) =>
      `linear-gradient(90deg,${theme.colors.bg} 10%,${theme.colors.bgOpacity})`};
    left: 0;
  }

  .nav-pills .styles-module_sliderBase__swkx1>[data-arrow=left]>button {
    background: url(https://cdn.dsmcdn.com/web/production/slick-arrow.svg) 50% no-repeat;
    border: none;
    cursor: pointer;
    height: 40px;
    left: -13px;
    outline: 0;
    -webkit-transform: rotate(180deg) scale(.5);
    transform: rotate(180deg) scale(.5);
    box-sizing: border-box;
    margin: 0em;
    padding: 1px 6px;
  }

  .nav-pills .styles-module_sliderBase__swkx1>[data-arrow=right] {
    bottom: 0;
    height: 42px;
    margin-bottom: auto;
    margin-top: auto;
    width: 88px;
    position: absolute;
    top: 0;
    opacity: 1;
    cursor: pointer;
    background: linear-gradient(270deg,#fff 10%,hsla(0,0%,100%,0));
    background: ${({ theme }) =>
      `linear-gradient(270deg,${theme.colors.bg} 10%,${theme.colors.bgOpacity})`};
    right: 0;
  }

  .nav-pills .styles-module_sliderBase__swkx1>[data-arrow=right]>button {
    background: url(https://cdn.dsmcdn.com/web/production/slick-arrow.svg) no-repeat;
    border: none;
    cursor: pointer;
    height: 40px;
    outline: 0;
    right: -16px;
    -webkit-transform: scale(.5);
    transform: scale(.5);
    box-sizing: border-box;
    margin: 0em;
    padding: 1px 150px;
  }

  .rowCardInfluencers {
    margin-right: 0;
    margin-left: 0;
    background: #dfe2e7;
    border-radius: 0.5rem;
  }

  .labelData p {
    margin-bottom: 0;
    margin-top: 1rem;
    margin-bottom: -1rem;
    padding: 0 0.9rem 0 0.75rem;
    color: #424242;
    font-weight: 400;
  }
`;
